import { Link } from "react-router-dom";
import type { MediaItem } from "@/types";
import { CATEGORY_LABELS } from "@/types";
import { formatDate } from "@/utils/media";

interface NewsRowProps {
  item: MediaItem;
  index?: number;
}

export default function NewsRow({ item, index }: NewsRowProps) {
  return (
    <Link
      to={`/detail/${item.id}`}
      className="group flex items-start gap-4 rounded-lg border border-transparent p-2 transition-colors hover:border-background-200 hover:bg-background-100/60"
    >
      <div className="relative h-20 w-28 shrink-0 overflow-hidden rounded-md bg-background-100">
        <img
          src={item.cover}
          alt={`${item.title} - 羞羞影视资讯`}
          title={item.title}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
      </div>
      <div className="min-w-0 flex-1">
        <div className="mb-1 flex items-center gap-2 text-xs">
          <span className="rounded bg-secondary-100 px-1.5 py-0.5 font-medium text-secondary-900">
            {CATEGORY_LABELS[item.category]}
          </span>
          <span className="text-foreground-400">{formatDate(item.releaseDate)}</span>
        </div>
        <h3 className="line-clamp-2 font-medium leading-snug text-foreground-900 transition-colors group-hover:text-primary-700">
          {index !== undefined && (
            <span className="mr-1.5 font-heading font-bold text-accent-600">{String(index + 1).padStart(2, "0")}</span>
          )}
          {item.title}
        </h3>
        <p className="mt-1 line-clamp-1 text-xs text-foreground-400">{item.summary}</p>
      </div>
    </Link>
  );
}